export default {
    domain: 'ដែន',
    domains: 'ដែន',
    alias: 'ឈ្មោះក្លែងក្លាយ',
    forward_to: 'បញ្ជូនបន្តទៅ',
    source_url: 'ប្រភព URL',
    destination_url: 'URL គោលដៅ',
    dns_setting: 'ការកំណត់ DNS',
    redirect_email: 'បញ្ជូនបន្តអ៊ីមែល',
    redirect_domain: 'ប្តូរទិសដែន',
    domain_contact: 'ទំនាក់ទំនងដែន',
    extend_domain: 'ពង្រីកដែន',
    reactivate_domain: 'ដំណើរការដែនឡើងវិញ',
    domain_status_info: {
        active: 'បច្ចុប្បន្ន ដែន​កំពង់ដំណើរការ',
        expired: 'ដែនបានផុតកំណត់ហើយ។',
        alert: 'ដែនមានរយៈពេលតិចជាង 30 ថ្ងៃរហូតដល់ផុតកំណត់',
        grace: '"ដែនបានផុតកំណត់ក្នុងរយៈពេល 30 ថ្ងៃ។ វាអាចទៅរួចសម្រាប់អ្នកក្នុងការទិញដែនម្តងទៀត។"',
        transferred: 'ដែនត្រូវបានផ្ទេរទៅម្ចាស់ថ្មី',
    },
    reg_date: 'កាលបរិច្ឆេទចុះឈ្មោះ',
    next_due: 'ផុតកំណត់បន្ទាប់',
    status: 'ស្ថានភាព',
    created_date: 'កាលបរិច្ឆេទបង្កើត',
    dns_management: 'ការគ្រប់គ្រង DNS',
    advanced_dns_setting: 'Advanced DNS Setting',
    what_is_dns_management: 'តើការគ្រប់គ្រង DNS គឺជាអ្វី?',
    learn_more: 'ស្វែង​យល់​បន្ថែម',
    type: 'Type',
    host: 'Host',
    value: 'Value',
    ttl: 'TTL',
    priority: 'Priority',
    add_new_record: 'បន្ថែមកំណត់ត្រាថ្មី។',
    set_up_two_click: 'ដំឡើងកម្មវិធីរបស់អ្នកដោយចុចពីរដង',
    choose_dns_template: 'ជ្រើសរើសគំរូ DNS',
    dns_template_content: {
        1: 'កំណត់ត្រា DNS របស់អ្នកនឹងត្រូវបានបង្កើតឡើងដើម្បីចង្អុលដែនរបស់អ្នកទៅកាន់កម្មវិធីដែលអ្នកជ្រើសរើស។',
        2: 'ស្វែងយល់បន្ថែមអំពីលក្ខណៈពិសេសនេះនៅក្នុង <a href="" class="text-cinnabar text-underline">មូលដ្ឋានចំណេះដឹង។</a> របស់យើង។',
    },
    txt_record: 'TXT Record',
    mx_record: 'MX Record',
    mxe_record: 'MXE Record',
    mail_setting: {
        1: 'ត្រូវការបន្ថែម ឬធ្វើបច្ចុប្បន្នភាព?',
        2: 'អ៊ីមែលឯកជនបានកំណត់រចនាសម្ព័ន្ធដោយស្វ័យប្រវត្តិសម្រាប់ google.com',
    },
    ip_address: 'អាស័យដ្ឋាន IP',
    personal_dns_servers: '"ម៉ាស៊ីនមេ DNS ផ្ទាល់ខ្លួន',
    learn_feature: 'រៀនប្រើមុខងារនេះ',
    register_name_server: '"ចុះឈ្មោះ ឈ្មោះម៉ា់ស៉ីនមេ',
    nameserver: 'ឈ្មោះម៉ា់ស៉ីនមេ',
    find_nameserver: '"ស្វែងរក ឈ្មោះម៉ា់ស៉ីនមេ',
    standard_server: 'ឈ្មោះម៉ា់ស៉ីនមេ ស្តង់ដារ',
    auto_renew: 'បន្តដោយស្វ័យប្រវត្តិ',
    expired_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    with_held_for_privacy: 'អ្វីដែលត្រូវបានទុកសម្រាប់ភាពឯកជន',
    protection: 'ការការពារ',
    basic_dns: 'DNS មូលដ្ឋាន',
    custom_dns: 'DNS ផ្ទាល់ខ្លួន',
    onebyte_dns: '1Byte DNS',
    onebyte_wp_dns: '1Byte WP Hosting DNS',
    add_nameserver: 'បន្ថែមឈ្មោះម៉ាស៊ីនមេ',
    nameserver_hint:
        'ឈ្មោះម៉ា់ស៉ីនមេ ជួយភ្ជាប់ URLs ជាមួយអាស័យដ្ឋាន IP របស់ web servers ។ Nameservers គឺជាផ្នែកមួយដ៏សំខាន់នៃប្រព័ន្ធ ប្រព័ន្ធឈ្មោះដែន (DNS) ដែលមនុស្សជាច្រើនហៅថា "សៀវភៅទូរស័ព្ទនៃអ៊ីនធឺណិត" ។',
    redirect_email_tips:
        'មុខងារបញ្ជូនបន្តអ៊ីមែលឥតគិតថ្លៃរបស់យើងអនុញ្ញាតឱ្យអ្នកបង្កើតអាសយដ្ឋានអ៊ីមែលផ្ទាល់ខ្លួនសម្រាប់ដែន និងបញ្ជូនអ៊ីមែលទៅអាសយដ្ឋានអ៊ីមែលផ្សេងទៀតតាមជម្រើសរបស់អ្នក។',
    redirect_email_tip_detail:
        'ប្ដូរទិលអ៊ីមែល (Email Redirect) គឺជាសេវាកម្មឥតគិតថ្លៃដែលអនុញ្ញាតឱ្យអ្នកទទួលបានអ៊ីមែលនៅអាស័យដ្ឋានអ៊ីមែលផ្ទាល់ខ្លួនyou@yourdomain.com ដោយបញ្ជូនពួកគេទៅកាន់គណនីអ៊ីមែលមួយផ្សេងទៀត។ ប្រសិនបើអ្នកកំពុងប្រើអ៊ីមែលឯកជន សូមប្រើចំណុចប្រទាក់របស់វា ដើម្បីរៀបចំការបញ្ជូនបន្ត។',
    what_does_it_do: 'តើ​វា​ធ្វើអ្វី?',
    redirect_email_contact_hint:
        'ដែននីមួយៗដែលបានចុះឈ្មោះត្រូវតែរួមបញ្ចូលនឹងព័ត៌មានទំនាក់ទំនងលម្អិត។ ទាំងនេះត្រូវបានរក្សាទុកក្នុងមូលដ្ឋានទិន្នន័យ WHOIS សាធារណៈ ដូច្នេះម្ចាស់ដែនអាចត្រូវបានទាក់ទងតាមតម្រូវការ។ យើងហៅថា "ទំនាក់ទំនងដែន" (aka. Whois Contacts) ។ អតិថិជនអាចធ្វើការកែសម្រួលបាន។',
    learn_more_personal: 'ស្វែងយល់បន្ថែមអំពីទំនាក់ទំនងដែនផ្ទាល់ខ្លួន',
    modal_edit_contact_title: 'កែសម្រួលទំនាក់ទំនង',
    setting: 'ការកំណត់',
    mail_settings: 'ការកំណត់សំបុត្រ',
    personal_dns_server: 'ម៉ាស៊ីនមេ DNS ផ្ទាល់ខ្លួន',
    host_record: 'HOST RECORDS',
    host_record_text:
        'អ្នកអាចគ្រប់គ្រងកំណត់ត្រាម៉ាស៊ីននៅក្នុងគណនី cPanel របស់អ្នក ឬផ្ទេរ DNS ត្រឡប់ទៅ 1Byte Basic DNS ដើម្បីគ្រប់គ្រងកំណត់ត្រានៅទីនេះ។',
    mail_setting_text:
        'អ្នកអាចគ្រប់គ្រងការកំណត់សំបុត្រនៅក្នុងគណនី cPanel របស់អ្នក ឬផ្ទេរ DNS ត្រឡប់ទៅ 1Byte Basic DNS ដើម្បីគ្រប់គ្រងកំណត់ត្រានៅទីនេះ',
    domain_transfer: 'ផ្ទេរដែន',
    transfer_in: 'ផ្ទេរចូល',
    domain_transfer_search: {
        title: 'ចាប់ផ្តើមការផ្ទេរដែន',
        subtitle:
            'បញ្ចូលដែនរបស់អ្នកខាងក្រោម ហើយអនុញ្ញាតឱ្យយើងណែនាំអ្នកតាមរយៈដំណើរការនេះ។',
        placeholder: 'បញ្ចូលឈ្មោះដែនរបស់អ្នកនៅទីនេះ',
    },
    domain_transfer_error: {
        not_available: {
            title: 'ដែន {domain} របស់អ្នកមិនមានសម្រាប់ផ្ទេរទេ។',
            description:
                'សូមព្យាយាមស្វែងរកដែនរបស់អ្នកម្តងទៀតនៅក្នុងប្រអប់ស្វែងរកខាងលើ ឬទាក់ទងក្រុមគាំទ្ររបស់យើងសម្រាប់ជំនួយ។',
        },
        not_yet_purchased: {
            title: 'ដែន {domain} របស់អ្នកមិនទាន់ត្រូវបានទិញនៅឡើយទេ',
            description:
                'សូមព្យាយាមស្វែងរកដែនរបស់អ្នកម្តងទៀតនៅក្នុងប្រអប់ស្វែងរកខាងលើ ឬទាក់ទងក្រុមគាំទ្ររបស់យើងសម្រាប់ជំនួយ។',
        },
        already_exists: {
            title: 'ដែន {domain} របស់អ្នកមានរួចហើយនៅក្នុងប្រព័ន្ធរបស់យើង',
            description:
                'សូមព្យាយាមស្វែងរកដែនរបស់អ្នកម្តងទៀតនៅក្នុងប្រអប់ស្វែងរកខាងលើ ឬទាក់ទងក្រុមគាំទ្ររបស់យើងសម្រាប់ជំនួយ។',
        },
    },
    transfer_checklist: 'ត្រួតពិនិត្យបញ្ជីផ្ទេរ',
    transfer_checklist_hint:
        'ដើម្បីធានាបាននូវការផ្ទេរប្រាក់ដោយជោគជ័យ សូមអនុវត្តតាមបញ្ជីត្រួតពិនិត្យការផ្ទេររបស់យើងខាងក្រោម។',
    transfer_checklist_alert:
        'ព័ត៌មាន​អស្ចារ្យ! ដែន {domain} របស់អ្នកមានសិទ្ធិផ្ទេរ។',
    year_transfer: 'ឆ្នាំផ្ទេរ | ឆ្នាំនៃការផ្ទេរ',
    current_registrar: 'អត្រានុកូលដ្ឋានបច្ចុប្បន្ន',
    authorization_code: 'កូដ​អនុញ្ញាត',
    authorization_code_placeholder: 'បញ្ចូលលេខកូដអនុញ្ញាតនៅទីនេះ',
    authorization_code_hint:
        'លេខកូដអនុញ្ញាតផ្ទេរដែន (ត្រូវបានគេស្គាល់ថាជាលេខកូដផ្ទៀងផ្ទាត់/ EPP Codes) ផ្តល់នូវស្រទាប់សុវត្ថិភាពបន្ថែមសម្រាប់ដែនរបស់អ្នក។ អ្នកនឹងត្រូវទទួលបានលេខកូដនេះពីអ្នកចុះឈ្មោះបច្ចុប្បន្នរបស់អ្នក។',
    domain_transfer_guide: {
        title: 'ដំណើរការផ្ទេរដែនសាមញ្ញរបស់ 1Byte',
        subtitle:
            'កំពុងរកមើលដើម្បីផ្ទេរដែនរបស់អ្នកយ៉ាងរលូន? ជាមួយនឹង 1Byte វាជារឿងងាយស្រួលបំផុត',
        domain_type_requirements: 'តម្រូវការប្រភេទដែន',
        steps: {
            1: {
                title: '1. ផ្ទៀងផ្ទាត់ដែនរបស់អ្នក។',
                description:
                    'បញ្ចូលដែនរបស់អ្នកទៅក្នុងរបារស្វែងរករបស់យើង ហើយត្រូវប្រាកដថាវាបំពេញតាមលក្ខខណ្ឌនៃការផ្ទេររបស់យើង។',
            },
            2: {
                title: '2. រៀបចំវាសម្រាប់ការផ្ទេរ',
                description:
                    'ពិនិត្យ {domainTypeRequirements} របស់អ្នក ហើយមានលេខកូដអនុញ្ញាតរបស់អ្នករួចរាល់។',
            },
            3: {
                title: '3. ផ្ទេរដែនរបស់អ្នក។',
                description:
                    'បន្តទៅការទូទាត់ជាមួយដែនរបស់អ្នក ធ្វើការទូទាត់ ហើយរំពឹងថានឹងបញ្ចប់ក្នុងរយៈពេល 30 នាទីទៅ 6 ថ្ងៃ។',
            },
        },
    },
    domain_transfer_faq: {
        title: 'សំណួរគេសួរញឹកញាប់លើការផ្ទេរដែន',
        subtitle:
            'សំណួររបស់អ្នកបានឆ្លើយ។ ស្វែងយល់បន្ថែមអំពីការផ្ទេរដែនជាមួយ 1Byte ។',
    },
};
